export default {
  JobBarcode: 'groupByJobID',
  ReasonDescription: 'groupByReason',
  AssetBarcode: 'groupByAssetID',
  ItemDescription: 'groupByItem',
  PerformedBy: 'groupByAssignee',
  Supervisor: 'groupBySupervisor',
}
